const FORM = {
    form: [],
    prevButton: [],
    nextButton: [],
    ctaButton: [],
    length: [],
    /*********************
    * Get all necessary parts of the form and look for the two form variants [ multi, complete ]
    *********************/
    onReady() {
        const forms = document.querySelectorAll('.form');
        var index = 0;
        forms.forEach(form => {
            this.form[index] = form;
            if (form.classList.contains('multi')) {
                this.prevButton[index] = form.querySelector('.form__navigation__button.left');
                this.nextButton[index] = form.querySelector('.form__navigation__button.right');
                this.length[index]     = form.querySelectorAll('.form__scene').length;
                FORM.build(index);
                FORM.listener(index);
                FORM.next(index);
                FORM.prev(index);
            } else {
                (form.parentNode.classList.contains('overlay--form')) && (form.parentNode.style.display = 'none'); // must be hidden by JS 
                this.ctaButton[index] = form.querySelector('.button--cta');
                FORM.cta(index);
            }
            index++;
        });
    },
    /*********************
    * Indexing all scenes of a multi form and, gets their individual heights and hides them if not active
    *********************/
    build(index) {
        let scenes = this.form[index].querySelectorAll('.form__scene');
        var sceneIndex = 1;
        var inputIndex = 0;
        scenes.forEach(scene => {
            scene.style.height = `${scene.clientHeight}px`;
            scene.dataset.step = sceneIndex;
            sceneIndex++;
            if (scene.classList.contains('active') === false) scene.classList.add('hidden');
            var inputs = scene.querySelectorAll('input');
            inputs.forEach(input => {
               input.dataset.index = inputIndex;
               inputIndex++; 
            });
        });
        let formWrapper = this.form[index].parentNode;
        (formWrapper.classList.contains('overlay--form')) && (formWrapper.style.display = 'none'); // must be hidden by JS because the scene heights must be calculated first
    },
    /*********************
    * Next button handler of a multi form
    *********************/
    next(index) {
        this.nextButton[index].addEventListener('click', event => {
            event.stopPropagation();
            let activeScene = this.form[index].querySelector('.form__scene.active');
            let inputs      = activeScene.querySelectorAll('input');
            let activeIndex = parseInt(activeScene.dataset.step);
            let nextIndex   = activeIndex + 1;
            let nextScene   = this.form[index].querySelector('.form__scene[data-step="' + nextIndex + '"]');
            // Last step, sends the form to the validation
            if (this.nextButton[index] && nextIndex > this.length[index]) {
                FORM.validate(event, index);
                return;
            }
            // Forth and back logic
            var isEmpty   = 0;
            var isChecked = 0;
            var checkbox;
            inputs.forEach(input => {
                // Scene with required input fields
                if (input.required && input.classList.contains('form__checkbox') === false) { // can be radios or checkboxes
                    (input.value === '') && isEmpty++;
                    checkbox = false;
                // Scene with not-required input fields
                } else if (input.required === false && input.classList.contains('form__checkbox') === false) {
                    isEmpty = (isEmpty > 0) ? isEmpty : 0;
                    checkbox = false;
                // Scene with checkboxes or radios
                } else {
                    checkbox = true;
                    (input.checked) && isChecked++;
                    // (isChecked > 0 && isEmpty === 0) && FORM.transition(index, activeScene, nextScene);
                    (isChecked > 0 && isEmpty === 0) && FORM.validateStep(index, activeScene, nextScene);
                    return;
                }
            });
            // (isEmpty === 0 && checkbox === false) && FORM.transition(index, activeScene, nextScene);
            (isEmpty === 0) && FORM.validateStep(index, activeScene, nextScene);
        });
    },
    /*********************
    * Prev button handler of a multi form
    *********************/
    prev(index) {
        this.prevButton[index].addEventListener('click', event => {
            event.stopPropagation();
            let activeScene = this.form[index].querySelector('.form__scene.active');
            let activeIndex = parseInt(activeScene.dataset.step);
            let prevIndex   = activeIndex - 1;
            let prevScene   = this.form[index].querySelector('.form__scene[data-step="' + prevIndex + '"]');
            if (prevIndex < 1) return;
            FORM.transition(index, activeScene, prevScene);
        });
    },
    /*********************
    * Status bar logic of a multi form
    *********************/
    statusbar(index, activeScene) {
        let activeIndex = parseInt(activeScene.dataset.step);
        let scenes      = this.form[index].querySelectorAll('.form__scene').length;
        let step        = activeIndex / scenes * 100;
        let statusbar   = this.form[index].querySelector('.form__navigation__percentage');
        statusbar.style.right = `${ 100 - step }%`;
        if (step === 100) {
            statusbar.classList.add('full');
        } else {
            statusbar.classList.remove('full');
        }
    },
    /*********************
    * Activates the next button on [ click, keypress ] events
    *********************/
    listener(index) {
        ['click', 'keypress'].forEach(event => {
            this.form[index].addEventListener(event, evt => {
                let activeScene = this.form[index].querySelector('.form__scene.active');
                let inputs      = activeScene.querySelectorAll('input');
                for (ii = 0; ii < inputs.length; ii++) {
                    var type = inputs[ii].type;
                    this.nextButton[index].classList.remove('next');
                    if (type === 'radio') {
                        if (inputs[ii].checked) {
                            this.nextButton[index].classList.add('next');
                            // this.nextButton[index].click();
                            return;
                        }
                    } else if (type === 'checkbox') {
                        if (inputs[ii].checked) {
                            this.nextButton[index].classList.add('next');
                            return;
                        }
                    } else if (type === 'text' || type === 'email' || type === 'tel' || type === 'number' || type === 'url') {
                        if (evt.key === 'Enter') {
                            this.nextButton[index].classList.add('next');
                            this.nextButton[index].click();
                            return;
                        } else {
                            if (evt.target.tagName !== 'INPUT' || evt.target.value.length < 1) return;
                            this.nextButton[index].classList.add('next');
                            return;
                        }
                    }
                }
            });
        });
    },
    /*********************
    * CTA Button handler of a complete form
    *********************/
    cta(index) {
        this.ctaButton[index].addEventListener('click', event => {
            event.stopPropagation();
            FORM.validate(event, index, this.ctaButton[index]);
        });
    },
    /*********************
    * Handles scene transitions of a multi form and sets the focused input field of the next scene
    *********************/
    transition(index, activeScene, newScene) {
        let activeElement    = document.activeElement;
        let statusbar        = this.form[index].querySelector('.form__navigation__percentage');
        let sceneTransition  = parseFloat(getComputedStyle(activeScene)['transitionDuration']) * 1000;
        let statusTransition = parseFloat(getComputedStyle(statusbar)['transitionDuration']) * 1000;
        if (activeElement.classList.contains('form__input')) {
            var nextTextInput = this.form[index].querySelector('input[data-index="'+ (parseInt(activeElement.dataset.index) + 1) +'"]');
            nextTextInput.focus();
            nextTextInput.select();
        }
        FORM.statusbar(index, newScene);
        setTimeout(() => {
            activeScene.classList.add('hidden');
            activeScene.classList.remove('active');
            newScene.classList.remove('hidden');
            newScene.classList.add('active');
            this.nextButton[index].classList.remove('next');
        }, statusTransition);
    },
    /*********************
    * Step Validation
    *********************/
    validateStep(index, activeScene, newScene) {
        let email = activeScene.querySelector('input[type="email"]');
        let phone = activeScene.querySelector('input[type="tel"]');
        // reset the form
        let inputs    = activeScene.getElementsByTagName('input');
        let textareas = activeScene.getElementsByTagName('textarea');
        for (i = 0; i < inputs.length; i++) {
            inputs[i].classList.remove('error');
        }
        for (j = 0; j < textareas.length; j++) {
            textareas[j].classList.remove('error');
        }
        var error = 0;
        //check required
        for (i = 0; i < inputs.length; i++) {
            if (inputs[i].required && inputs[i].value === '') {
                inputs[i].classList.add('error');
                error++
            } else if (inputs[i].required && inputs[i].type === 'radio') {
                let radios = document.querySelectorAll('input[name="'+ inputs[i].name +'"]:checked');
                if (radios.length < 1) {
                    inputs[i].classList.add('error');
                    error++;
                }
            } else if (inputs[i].required && inputs[i].type === 'checkbox') {
                let checkboxes = document.querySelectorAll('input[data-checkbox-group="'+ inputs[i].dataset.checkboxGroup +'"]:checked');
                if (checkboxes.length < 1) {
                    inputs[i].classList.add('error');
                    error++;
                }
            }
        }
        for (j = 0; j < textareas.length; j++) {
            if (textareas[j].required && textareas[j].value === '') {
                textareas[j].classList.add('error');
                error++;
            }
        }
        //check email format
        if ( email !== null ) {
            var regex_email = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
            if (regex_email.test( email.value ) === false && email.required) {
                email.classList.add('error');
                error++;
            }
        }
        // check phone format + length
        if ( phone !== null ) {
            var regex_phone = new RegExp(/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g);
            if (phone.value !== '' && phone.required === false) {
                if (regex_phone.test( phone.value ) === false) {
                    phone.classList.add('error');
                    error++;
                }
                if (phone.value.length < 8) {
                    phone.classList.add('error');
                    error++;
                }
            } else if (phone.required) {
                if (regex_phone.test( phone.value ) === false) {
                    phone.classList.add('error');
                    error++;
                }
                if (phone.value.length < 8) {
                    phone.classList.add('error');
                    error++;
                }
            }
        }
        // proceed or return
        if (error > 0) {
            this.form[index].classList.add('error');
            return;
        } else {
            this.form[index].classList.remove('error');
            FORM.transition(index, activeScene, newScene)
        }
    },
    /*********************
    * For validation
    *********************/
    validate(event, index, that = null) {
        event.preventDefault(); // Form submit must be prevented 
        (that !== null) && (that.disabled = true);
        OVERLAY.loading();
        let email = this.form[index].querySelector('input[type="email"]');
        let phone = this.form[index].querySelector('input[type="tel"]');
        // reset the form
        let inputs    = this.form[index].getElementsByTagName('input');
        let textareas = this.form[index].getElementsByTagName('textarea');
        for (i = 0; i < inputs.length; i++) {
            inputs[i].classList.remove('error');
        }
        for (j = 0; j < textareas.length; j++) {
            textareas[j].classList.remove('error');
        }
        var error = 0;
        //check required
        for (i = 0; i < inputs.length; i++) {
            if (inputs[i].required && inputs[i].value === '') {
                inputs[i].classList.add('error');
                error++
            } else if (inputs[i].required && inputs[i].type === 'radio') {
                let radios = document.querySelectorAll('input[name="'+ inputs[i].name +'"]:checked');
                if (radios.length < 1) {
                    inputs[i].classList.add('error');
                    error++;
                }
            } else if (inputs[i].required && inputs[i].type === 'checkbox') {
                let checkboxes = document.querySelectorAll('input[data-checkbox-group="'+ inputs[i].dataset.checkboxGroup +'"]:checked');
                if (checkboxes.length < 1) {
                    inputs[i].classList.add('error');
                    error++;
                }
            }
        }
        for (j = 0; j < textareas.length; j++) {
            if (textareas[j].required && textareas[j].value === '') {
                textareas[j].classList.add('error');
                error++;
            }
        }
        //check email format
        if ( email !== null ) {
            var regex_email = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
            if (regex_email.test( email.value ) === false && email.required) {
                email.classList.add('error');
                error++;
            }
        }
        // check phone format + length
        if ( phone !== null ) {
            var regex_phone = new RegExp(/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g);
            if (phone.value !== '' && phone.required === false) {
                if (regex_phone.test( phone.value ) === false) {
                    phone.classList.add('error');
                    error++;
                }
                if (phone.value.length < 8) {
                    phone.classList.add('error');
                    error++;
                }
            } else if (phone.required) {
                if (regex_phone.test( phone.value ) === false) {
                    phone.classList.add('error');
                    error++;
                }
                if (phone.value.length < 8) {
                    phone.classList.add('error');
                    error++;
                }
            }
        }
        // proceed or return
        if (error > 0) {
            document.getElementById('overlay-loading').remove();
            this.form[index].classList.add('error');
            (that !== null) && (that.disabled = false);
            return;
        } else {
            let ctaButton = this.form[index].querySelector('.button--cta');
            (ctaButton !== null) && (ctaButton.disabled = true);
            this.form[index].classList.remove('error');
            FORM.sendData(index);
        }
    },
    /*********************
    * Show the response
    *********************/
    response(index, markup) {
        (this.form[index].nextElementSibling !== null) && this.form[index].nextElementSibling.remove(); // data privacy disclaimer
        this.form[index].insertAdjacentHTML('afterend', markup);
        this.form[index].remove();
    },
    /*********************
    * Sends the data over a XHR request
    *********************/
    sendData(index) {
        let getUrl   = window.location;
        let baseUrl  = getUrl.protocol + '//' + getUrl.hostname + '/';
        let formData = FORM.serialize(this.form[index]);
        let handler  = 'handler.XHR.php?handler=' + this.form[index].dataset.handler;
        let xhr      = new XMLHttpRequest();
        xhr.open('POST', baseUrl + 'inc/' + handler, true);
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        xhr.onload = (e) => {
            if (xhr.readyState === 4) {
                if (xhr.status === 200 && xhr.response === 'success') {
                    var responseStatus = 'success';
                    var responseText   = this.form[index].querySelector('.form__responses .success[data-response="success"]').innerHTML;
                    TRACKING.formEvents({
                        form: this.form[index], 
                        action: 'FORM-VERSAND'
                    });
                } else if (xhr.status === 200 && xhr.response === 'error') {
                    var responseStatus = 'error';
                    var responseText   = this.form[index].querySelector('.form__responses .error[data-response="error"]').innerHTML;
                } else if (xhr.status === 200 && xhr.response === 'already registered') {
                    var responseStatus = 'success';
                    var responseText   = this.form[index].querySelector('.form__responses .success[data-response="already-registered"]').innerHTML;
                } else if (xhr.status === 200 && xhr.response === 'too many tries') {
                    var responseStatus = 'error';
                    var responseText   = this.form[index].querySelector('.form__responses .error[data-response="too-many-tries"]').innerHTML;
                } else {
                    var responseStatus = 'error';
                    var responseText   = this.form[index].querySelector('.form__responses .error[data-response="error"]').innerHTML;
                }
                let markup = `<div class="form--response ${responseStatus}">${responseText}</div>`;
                FORM.response(index, markup);
                document.getElementById('overlay-loading').remove();
            }
        };
        xhr.onerror = (e) => {
            var responseText = this.form[index].querySelector('.form__responses .error[data-response="error"]').innerHTML;
            var markup = '<div class="form--response error">' + responseText + '</div>';
            FORM.response(index, markup);
            document.getElementById('overlay-loading').remove();
        };
        xhr.send(formData);
    },
    /*********************
    * Input serialiser 
    *********************/
    serialize(form) {
        var serialized = [];
        for (var i = 0; i < form.elements.length; i++) {
            var field = form.elements[i];
            if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;
            if (field.type === 'select-multiple') {
                for (var n = 0; n < field.options.length; n++) {
                    if (!field.options[n].selected) continue;
                    serialized.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(field.options[n].value));
                }
            } else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
                serialized.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value));
            }
        }
        return serialized.join('&');
    }
}